const AdleaksRoutes = {
  getAllAdleaks: "/blog/getallblogsWEB"
}

export default AdleaksRoutes;